$(function(){
  /*
   * For the sake keeping the code clean and the examples simple this file
   * contains only the plugin configuration & callbacks.
   *
   */


  // Creates a new file and add it to our list
  function ui_multi_add_file(id, file, document_demarche_id)
  {
    var template = $('#files-template').text();
    template = template.replace('%%filename%%', file.name);
    template = template.replace('%%uniq_filename%%', file.lastModified);

    //template = template.replace('%%filesize%%', formatFileSize(file.size).replace('.', ','));  //taille du fichier

    template = $(template);
    template.prop('id', 'uploaderFile' + id);
    //template.data('file-id', file.lastModified);

    $('.documents-demarche-id-'+document_demarche_id).find('li.empty').fadeOut(); // remove the 'no files yet'
    $('.documents-demarche-id-'+document_demarche_id).append(template);

    $('#aucun-fichier').hide();
  }

// Changes the status messages on our list
  function ui_multi_update_file_status(id, status, message, document_demarche_id)
  {
    $('#uploaderFile' + id + ', #uploaderFile ' + id + ' .documents-demarche-id-'+document_demarche_id).find('.status').html(message).prop('class', 'status text-' + status);
  }

// Updates a file progress, depending on the parameters it may animate it or change the color.
  function ui_multi_update_file_progress(id, percent, document_demarche_id)
  {
    if (percent === 100){
      $('#uploaderFile' + id + ', #uploaderFile ' + id + ' .documents-demarche-id-'+document_demarche_id).find('.avancement').text('');
    } else {
      $('#uploaderFile' + id + ', #uploaderFile ' + id + ' .documents-demarche-id-'+document_demarche_id).find('.avancement').text(percent + '%');
    }

  }

// Helper function that formats the file sizes
  function formatFileSize(bytes) {
    if (typeof bytes !== 'number') {
      return '';
    }
    if (bytes >= 1000000000) {
      return (bytes / 1000000000).toFixed(2) + ' go';
    }
    if (bytes >= 1000000) {
      return (bytes / 1000000).toFixed(2) + ' mo';
    }
    return (bytes / 1000).toFixed(2) + ' octets';
  }


  $('.drag-and-drop-zone2').multipleUploader({
    url: $('.drag-and-drop-zone2').data('route'),

    data: {
      document_demarche_id: $('.drag-and-drop-zone2').data('document-demarche-id')
    },

    //maxFileSize: 5000000, // 50 Megs
    onDragEnter: function(){
      // Happens when dragging something over the DnD area
      this.addClass('active');
    },
    onDragLeave: function(){
      // Happens when dragging something OUT of the DnD area
      this.removeClass('active');
    },
    onInit: function(){
      // Plugin is ready to use
    },
    onComplete: function(){
      // All files in the queue are processed (success or error)
      location.reload();
    },
    onNewFile: function(id, file, document_demarche_id){
      // When a new file is added using the file selector or the DnD area

      console.log('dragggg00');

      ui_multi_add_file(id, file, document_demarche_id);
    },
    onBeforeUpload: function(id, document_demarche_id){
      // about tho start uploading a file
      ui_multi_update_file_status(id, '', '...', document_demarche_id);
      ui_multi_update_file_progress(id, 0, document_demarche_id);
    },
    onUploadCanceled: function(id) {
      // Happens when a file is directly canceled by the user.
      ui_multi_update_file_status(id, 'warning', 'Annulé');
      ui_multi_update_file_progress(id, 0);
    },
    onUploadProgress: function(id, percent, document_demarche_id){
      // Updating file progress
      ui_multi_update_file_progress(id, percent, document_demarche_id);
    },
    onUploadSuccess: function(id, data, document_demarche_id){
      // A file was successfully uploaded
      ui_multi_update_file_status(id, 'success', '100%', document_demarche_id);
      ui_multi_update_file_progress(id, 100, document_demarche_id);
    },
    onUploadError: function(id, xhr, status, message, document_demarche_id){
      ui_multi_update_file_status(id, 'danger', 'Erreur', document_demarche_id);
      ui_multi_update_file_progress(id, 0, document_demarche_id, document_demarche_id);
    },
    onFallbackMode: function(){
      // When the browser doesn't support this plugin :(
    },
    onFileSizeError: function(file){
    }
  });

});